import React from "react";
import { Card, Row, Tag, Col, Button } from "antd";
class FilterContent extends React.Component {
  render() {
    return (
      <Card>
        <Row justify="space-between">
          <Col order={2}>
            <Button
              size="small"
              onClick={this.props.onDateClear}
              style={{ width: 120 }}
            >
              清空
            </Button>
          </Col>
          <Col order={1}>
            {this.props.priceType.map((type) => (
              <Row
                key={"priceType" + type.pricetype_name}
                gutter={[16, 16]}
                style={{
                  display: Object.values(this.props.dateSetting).includes(
                    type.pricetype_id
                  )
                    ? "flex"
                    : "none",
                }}
              >
                <Col style={{ minWidth: 70 }}>{type.pricetype_name}</Col>
                <Col>
                  {Object.keys(this.props.dateSetting).map((date, index) => {
                    if (this.props.dateSetting[date] === type.pricetype_id) {
                      return (
                        <Tag
                          key={"tag" + index}
                          closable
                          onClose={this.props.onDateTagDelete.bind(this, date, type.pricetype_id)}
                        >
                          {date}
                        </Tag>
                      );
                    } else {
                      return null;
                    }
                  })}
                </Col>
              </Row>
            ))}
          </Col>
        </Row>
      </Card>
    );
  }
}
export default FilterContent;
